import { useQuery } from '@tanstack/react-query';
import { MessageSquare } from 'lucide-react';
import { Link } from 'react-router-dom';

import { getUnreadMessageCount, STUDENT_MESSAGE_KEYS } from './messages-api';
import s from './UnreadMessagesCard.module.css';

/**
 * "Your institute has written to you" on the student home (phase 179a).
 *
 * Renders NOTHING when there is nothing unread — the same rule as
 * `ContinueCard` and `DocumentsNeededCard`: an offer that appears only when it
 * has something honest to say. This is the entry point that actually works;
 * the nav rows are for people already looking.
 */
export function UnreadMessagesCard(): JSX.Element | null {
  const query = useQuery({
    queryKey: STUDENT_MESSAGE_KEYS.unread,
    queryFn: getUnreadMessageCount,
    staleTime: 30 * 1000,
    refetchOnWindowFocus: true,
  });

  const unread = query.data ?? 0;
  if (unread === 0) return null;

  return (
    <Link className={s.root} to="/student/messages">
      <span className={s.icon} aria-hidden="true">
        <MessageSquare size={18} />
      </span>
      <span className={s.body}>
        <span className={s.title}>
          {unread === 1 ? '1 new message' : `${String(unread)} new messages`}
        </span>
        <span className={s.hint}>From your teachers and counsellors. Tap to read and reply.</span>
      </span>
    </Link>
  );
}
